import { GoogleDocLegalPage } from './legal/GoogleDocLegalPage';
import { LEGAL_DOCUMENTS } from './legal/legalDocuments';

export const Privacy = () => <GoogleDocLegalPage document={LEGAL_DOCUMENTS.privacyPolicy} />;
